const ApiSuffix = {
  sendOTP: "/api/send-otp/?mobile=",
  verifyOTP: "/api/verify-otp/",
  registerUser: "/api/register-user/",
  getAllCourses: "/api/get-all-courses/",
  getCourseInfo: "/api/get-course-info/?displayURL=",
  applyDiscountCoupon: "/api/apply-discount-coupon/",
  createPaymentReq: "/api/create-payment-request/",
  getMyCourses: "/api/my-courses/",
  viewMyCourse: "/api/view-my-course/?id=",
  getPlaybackUrl: "/api/get-playback-url/?ulmID=",
  getTeacherInfo: "/api/get-teacher-info/?teacherID=",
  markLectureAsComplete: "/api/mark-lecture-as-completed/?ulmID=",
  editNotes: "/api/edit-notes/",
  getReviews: "/api/get-reviews/",
  generateCertificate: "/api/generate-certificate/",
  getCertificate: "/api/get-certificate/?certificate_id=",

  getAllBlogs: "/api/get-blogs/",
  getBlogDetail: "/api/get-blogs/?url=",
};

export default ApiSuffix;
